export default __webpack_public_path__ + "static/media/gulls.c4884646.jpg";